import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content-wrapper" }

import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import StudentInformationForm from "./StudentInformationForm.vue";
import type { StudentVM } from "@/models/student";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentInformationModal',
  props: {
    loading: { type: Boolean },
    disabled: { type: Boolean },
    student: {}
  },
  emits: ["studentUpdated", "close"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const gettingData = ref<boolean>(true);

function close() {
  emit("close");
}

onMounted(async () => {
  await store.dispatch(
    "applicationInfoModule/getStudentInfo",
    store.state.appData.application.referenceId,
  );

  gettingData.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    closeBtnHidden: __props.loading,
    allowClickOutsideToClose: false,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Edit Student Information", -1)),
        _createVNode(StudentInformationForm, {
          onStudentUpdated: _cache[0] || (_cache[0] = ($event: any) => (emit('studentUpdated', $event))),
          disabled: __props.loading,
          loading: __props.loading || gettingData.value,
          student: __props.student
        }, null, 8, ["disabled", "loading", "student"])
      ])
    ]),
    _: 1
  }, 8, ["closeBtnHidden"]))
}
}

})